import React from 'react';
import { Crown, Heart, Sparkles, ArrowRight, Camera, Users, MessageCircle, QrCode, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HeroSectionProps {
  onContactClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onContactClick }) => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/auth/login');
  };

  return (
    <section className="hero-section" role="banner" aria-label="Photo Memorial サービス紹介">
      <div className="hero-background">
        <div className="hero-decoration">
          <div className="hero-circlhero-sectione-1"></div>
          <div className="hero-circle-2"></div>
          <div className="hero-circle-3"></div>
        </div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          結婚式の感動を <br />みんなで共有する
        </h1>

        <p className="hero-subtitle">Wedding Photo Memorial</p>

        <h2 className="hero-catchcopy">
          <span className="highlight-text">QRコード</span>で簡単アクセス。<br />
          写真・コメントが<span className="highlight-text">リアルタイム</span>で会場スクリーンに
        </h2>

        <p className="hero-description">
          式場スタッフの皆様へ
        </p>

        <p className="hero-description">
          ゲストの撮影した写真を瞬時に共有し <br />
          感動の瞬間を会場全体で分かち合える <br />
          革新的なサービスです。<br />
          モデレーション機能付きで安心して <br />
          ご利用いただけます。
        </p>

      </div>
    </section>
  );
};

export default HeroSection;